'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useAuth } from '@/context/AuthContext';
import { trackPageView } from '@/lib/api-client';

export default function PageViewTracker() {
  const pathname = usePathname();
  const { user } = useAuth();
  const lastTracked = useRef<string>('');

  useEffect(() => {
    if (pathname === lastTracked.current) return;
    if (pathname.startsWith('/admin')) return;
    lastTracked.current = pathname;
    trackPageView(pathname, user?.id);
  }, [pathname, user?.id]);

  return null;
}
